$(function () {
	const block = document.querySelector('[data-home-seo]');
	if (!block) {
		return;
	}

	const content = block.querySelector('[data-home-seo-content]');
	const toggle = block.querySelector('[data-home-seo-toggle]');
	let expanded = false;

	function update() {
		const limit = parseFloat(window.getComputedStyle(block).getPropertyValue('--home-seo-preview-height')) || 240;
		const hasOverflow = content.scrollHeight > limit + 1;

		block.classList.toggle('is-collapsed', hasOverflow && !expanded);
		toggle.hidden = !hasOverflow;
		toggle.setAttribute('aria-expanded', String(hasOverflow && expanded));
		toggle.textContent = expanded ? 'Свернуть' : 'Читать всё';
	}

	toggle.addEventListener('click', function () {
		expanded = !expanded;
		update();
	});

	// При переходе с клавиатуры ссылки в обрезанной части должны становиться видимыми.
	content.addEventListener('focusin', function () {
		if (!expanded) {
			expanded = true;
			update();
		}
	});

	update();
	window.addEventListener('load', update);
	window.addEventListener('resize', update);
});
